import { createContext, useContext, useState, useCallback, useMemo } from "react";

const SceneContext = createContext(null);

export const useScene = () => {
    const context = useContext(SceneContext);

    if (!context) {
        throw new Error(
            "useScene must be used inside SceneController"
        );
    }

    return context;
};

const SceneController = ({ children }) => {
    const [sceneState, setSceneState] = useState({
        section: "hero",
        chaos: 0.2,
        coreIntensity: 2,
        cameraDistance: 8,
        organization: 0,
    });

    const updateScene = useCallback((updates)=>{
        setSceneState(previous=>{
            const changed = Object.keys(updates)
                .some( key => previous[key] !== updates[key] );
            if(!changed){ return previous; }

            return { ...previous, ...updates };
        });
    },[]);

    const value = useMemo(()=>({
        sceneState,
        updateScene,
    }),[ sceneState, updateScene ]);

    return (
        <SceneContext.Provider value={value}>
            {children}
        </SceneContext.Provider>
    );
};

export default SceneController;